module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"manage_users":"UTILISATEURS","add":"Ajouter","find":"Rechercher","no_available_users":"Aucun utilisateur attaché à ce bâtiment"},"en":{"manage_users":"USERS","add":"Add","find":"Find","no_available_users":"No users attached to this building"}}')
  delete Component.options._Ctor
}
